module.exports = __webpack_public_path__ + "img/logo_white.3794c017.png";